import { apiMapper } from "./ApiMapper";

const EmployeeAPI = {
  LIST: (axiosPrivate, pageNumber, pageSize, employee_status) => {
    let url = `${apiMapper.employee.list}?page=${pageNumber}&page_size=${pageSize}`;
    if (employee_status) {
      url += `&employee_status=${encodeURIComponent(employee_status)}`;
    }
    return axiosPrivate.get(url);
  },
  ADD: (axiosPrivate, payload) => {
    return axiosPrivate.post(apiMapper.employee.add, payload);
  },
  UPDATE: (axiosPrivate, id, payload) => {
    return axiosPrivate.patch(`${apiMapper.employee.update}${id}`, payload);
  },
  DETAIL: (axiosPrivate, id) => {
    return axiosPrivate.get(`${apiMapper.employee.detail}${id}`);
  },
  DELETE: (axiosPrivate, employee_id, payload) => {
    return axiosPrivate.delete(`${apiMapper.employee.delete}${employee_id}`, {
      data: payload
    });
  },
  ACTIVITY_LOGS: (axiosPrivate, id) => {
    return axiosPrivate.get(
      `${apiMapper.employee.activityLogs}?employee_id=${id}`
    );
  }
};
export default EmployeeAPI;
